export default __webpack_public_path__ + "static/media/shift-arrow-filled.1db7e8c2.svg";